import { memo } from "react";
import { Handle, Position } from "reactflow";
import AbstractStandardNode from "../../customNodeTypes/AbstractStandardNode";

export default memo(({ type, isConnectable, data }: any) => {
    return (
        <AbstractStandardNode label={""} type={type}>
            <Handle
                type="target"
                id="waiter"
                position={Position.Bottom}
                isConnectable={isConnectable}
                style={{ left: (data.width ?? 30) - 15 }}
            />
        </AbstractStandardNode>
    );
});
